"use client";

import * as React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
const showcaseItems = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/node_infrastructure_01.png",
  caption: "Core Node v4.1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/neural_mesh_v2.png",
  caption: "Neural Mesh Sync"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/data_ingestion_stream.png",
  caption: "Ingestion Stream"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/encrypted_ledger_view.png",
  caption: "L2 Ledger Access"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/quantum_safe_encryption.png",
  caption: "Quantum Encryption"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/edge_compute_cluster.png",
  caption: "Edge Cluster"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/autonomous_routing.png",
  caption: "Autonomous Path"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/intelligence_layer_04.png",
  caption: "Protocol Layer"
}];
export default function VisualShowcase() {
  return;
}